var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDash3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 311.2 533.1",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m189.5 479.1v-18.4s-14-13.9-14-34.5l23.7-180.6c.5-4.8 2.9-9.2 6.5-12.4l.3-.2c9.2-8.2 23.9-7 31.4 2.5l65.2 71.2c2.3 3 3.6 6.8 3.6 10.6v161.8",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.2 479.1h-10v-161.8c0-2.6-.9-5.2-2.5-7.3l-65.1-71.2v-.2c-2.9-3.5-7-5.7-11.5-6-4.6-.4-9.2 1.1-12.7 4.1l-.3.3c-2.7 2.3-4.4 5.6-4.8 9.1l-23.8 180.5c.1 17.9 12.4 30.4 12.5 30.5l1.5 1.5v20.5h-10v-16.5c-3.9-4.5-14-17.9-14-36.4v-.6l23.7-180.7c.7-6 3.6-11.5 8.1-15.4l.3-.3c5.6-4.8 12.9-7.2 20.2-6.6 7.2.7 13.7 4.1 18.3 9.7l65.2 71.2.2.2c3 3.9 4.6 8.7 4.6 13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.6 39.7v349.6l-219.9 10.5c-9.2.4-17.1-6.4-17.6-15.2v-344.9z",
    fill: "#73c9df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.7 437.7h-169.7c-21.5 0-38.9-17.4-39-38.9v-364.1h247.6v365.7c0 .3-.1.7-.1 1s-.2 2.3-.3 3.3c-.1.4-.2.8-.2 1.2l-.3 1.3c-.1.6-.3 1.1-.4 1.7l-.3.9c0 .1 0 .3-.1.4v.2c-.1.5-.3 1.1-.5 1.6-.1.4-.3.9-.5 1.3l-.2.6-.9 2c-.2.2-.3.4-.4.7-1.2 2.3-2.6 4.5-4.3 6.6l-.7.9h-.1l-.9 1-1 1-.7.7-1.2 1.1c-.3.3-.6.6-1 .8h-.1v2.6h-3.4l-1.8 1.1-.6.3-.7.4-.5.2-1 .5c-2.6 1.2-5.2 2.1-8 2.7l-.9.2h-.1l-1 .2h-1.7c-1.6.4-3.3.6-5 .8zm-198.7-393v354.1c.1 16 13 28.9 29 28.9h169.7l3.7-.2h2.7c2.1-.5 4.1-1.2 6-2.1l.7-.3.3-.2.6-.3h.1l.4-.2 1.4-.8.9-.7.7-.5c.3-.2.6-.4.8-.7l.8-.6.9-.8.5-.5.7-.7v-.2l.6-.6h.1l.5-.6c1.2-1.6 2.3-3.2 3.2-5l.2-.4h.1l.6-1.4.2-.5.4-.9c.1-.4.3-.8.4-1.2l.2-.5c0-.2.1-.4.1-.6l.3-1.3c.1-.3.2-.6.2-.9.1-.3.1-.6.2-.9.1-.8.2-1.7.2-2.5.1-.2.1-.5.1-.7v-356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219 268.5-190.7-1.9v-193.9h190.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.1 111.6h-38v38h38zm-8.6 29.4h-20.8v-20.7h20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.8 227.3h38v-38h-38zm8.6-29.4h20.8v20.8h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.8 111.6h-38v38h38zm-8.6 29.4h-20.8v-20.7h20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.1 227.3h38v-38h-38zm8.6-29.4h20.8v20.8h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.2 121.8v20.6h-8.6v8.6h-8.6v5.3h8.6v8.2h-8.5-17.3v-8.6h-8.6v8.6h-8.7v8.6h-8.6v8.7h8.6 17.3 17.3v-8.7h8.6v-8.2h8.5v-8.6-5.3h8.6v-20.6-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.5 164.9h-17.3v16.9h-17.1v17.2h8.5v17.1h8.6v8.7h8.6v-8.7-17.2h-8.5v-8.1h8.5l.1-17.2h8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.4 182.2v-8.6h8.6v-8.7h-8.6-17.3v7.9h8.7v9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.9 216.1h8.6v8.6h-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.9 156.3h8.6v8.6h-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 156.3h8.6v8.6h-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 109.8h8.6v8.6h-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.5 156.3h8.6v8.6h-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.6 234.7h8.6v8.6h-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.7 151.4h8.8v-57.9h58.6v-8.8h-67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m142.2 84.3v8.8h57.9v58.7h8.8v-67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.9 187.3h-8.8v57.9h-58.7v8.8h67.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.4 254.4v-8.8h-57.9v-58.6h-8.8v67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 127.3h237.6v10h-237.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.6 370.7v28.1c0 18.7-15.2 33.9-33.9 33.9h-169.7c-18.7 0-33.9-15.2-34-33.9v-28.1z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.7 437.7h-169.7c-21.5 0-38.9-17.4-39-38.9v-33.1h247.6v33.1c0 21.5-17.4 38.9-38.9 38.9zm-198.7-62v23.1c.1 16 13 28.9 29 28.9h169.7c15.9-.1 28.8-13 28.9-28.9v-23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.3 397.8h42.4v10h-42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.6 39v.7h-237.6v-.7c0-18.8 15.2-34 34-34h169.7c18.7.1 33.9 15.3 33.9 34z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.6 44.7h-247.6v-5.7c.1-21.5 17.5-38.9 39-39h169.7c21.5.1 38.9 17.5 38.9 39zm-237.3-10h227c-2.1-14.2-14.3-24.7-28.6-24.7h-169.7c-14.4 0-26.6 10.5-28.7 24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m242.3 450.7s-25.6-21-30.5-47.1c-4.1-21.5 3.6-42.8 3.6-42.8l-34.3-37.3c-7.5-7.8-7.4-20.1.2-27.7s19.9-7.7 27.6-.3l66.3 65.3",
    fill: "#efcdb1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.2 454.6c-1.1-.9-27.2-22.5-32.4-50.1-3.3-18 .9-35.6 2.9-42.4l-32.2-35.2c-9.7-9.6-9.7-25.3-.1-35s25.3-9.7 35 0l66.3 65.3-7 7.1-66.3-65.2c-5.8-5.7-15.1-5.7-20.8.1s-5.7 15.1.1 20.8h.1l36.3 39.6-1 2.8c-.1.2-7.2 20.3-3.4 40.2 4.5 24 28.5 43.9 28.8 44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.5 479.1h116.8v49h-116.8z",
    fill: "#e87b1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.2 533.1h-126.7v-59h126.7zm-116.7-10h106.7v-39h-106.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash3);
export default __webpack_public_path__ + "static/media/dash3.3a952cd3a1a3370cbab66abff5a82826.svg";
export { ForwardRef as ReactComponent };